import styled from 'styled-components';
import { innerWidthThreshold } from 'utils/constants/app/magic-numbers-app';

export const Header = styled.div`
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  margin-bottom: 8px;
  flex-shrink: 0;
  background: var(--v3-black-0);
`;

export const StyledImg = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 6px;
`;

export const Content = styled.div`
  width: 100%;
  margin-top: -2%;
  height: 54%;
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: space-around;
  padding: 0
    ${window.innerWidth > innerWidthThreshold.WINDOW_WIDTH_THRESHOLD_1520
      ? '15%'
      : '10%'};
  font-size: 16px;
`;

export const TeamFlag = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 44px;
  max-width: 44px;

  & img {
    height: 100%;
    width: auto;
  }
`;

export const Flag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--v3-black-0);
  color: var(--v3-text-color);
  border-radius: 50%;
  font-size: 16px;
`;

export const MatchDetails = styled.div<{ $isOneGame: boolean }>`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1% 0;
  font-weight: 400;
  line-height: 1;
  text-align: center;
  color: var(--v3-white);
  padding: 0
    ${window.innerWidth > innerWidthThreshold.WINDOW_WIDTH_THRESHOLD_1350
      ? '10%'
      : '5%'};
  ${props =>
    !props.$isOneGame &&
    'border-left: 2px solid var(--v3-white); margin-top: 20px; text-align: start; padding: 0 0 0 24px;'}
`;

export const CompetitionName = styled.div`
  cursor: default;
  font-size: 14px;
  line-height: 20px;
`;

export const StartDay = styled.div`
  font-weight: 600;
  cursor: default;
  line-height: 24px;
`;

export const StartTime = styled.div`
  cursor: default;
  font-size: 14px;
  line-height: 20px;
`;

export const TeamName = styled.div`
  font-weight: 600;
  cursor: default;
  color: var(--v3-white);
  text-align: center;
  position: absolute;
  bottom: -27%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 10vw;
  line-height: 24px;
`;

export const SportImageOverlay = styled.div`
  background: rgb(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 6px;
`;

export const Avatar = styled.div`
  color: var(--v3-text-color);
  background-color: var(--v3-black-6);
  font-size: 16px;
  width: 44px;
  height: 44px;
  border-radius: 100%;
  display: flex;
  line-height: 1;
  align-items: center;
  justify-content: center;
`;
